import React, { useState } from 'react';
import './RedCactus.scss';

interface RedCactusProps{
  setIsRedCactusIconVisible:React.Dispatch<React.SetStateAction<boolean>>;
}

const RedCactus: React.FC<RedCactusProps> = ({
  setIsRedCactusIconVisible
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const hideIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsRedCactusIconVisible(false);
    setIsOpen(false);
  };

  const toggleBubble = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button className="floating-button" onClick={toggleBubble}>
        <span className="close-icon" onClick={hideIcon}>-</span>
        <img
          src={require("../../../assets/images/icon.png")}
          alt="RedCactus Icon"
        />
      </button>
      {isOpen && (
        <div className="iframe-bubble">
          <iframe src="https://eu.bubble365.app" title="RedCactus Bubble" />
        </div>
      )}
    </>
  );
};

export default RedCactus;